export const CHART_CARD_SURFACE = {
	PRESET: 'preset',
	HOME: 'home',
	SNAPSHOT: 'snapshot',
};

/** 经营看板 / 首页固定图共用外壳（与 PRESET 流程页区块区分） */
export const isBoardChartCardSurface = (surface) =>
	surface === CHART_CARD_SURFACE.HOME || surface === CHART_CARD_SURFACE.SNAPSHOT;

/**
 * HOME / SNAPSHOT 共用 article 壳；class 仍分两套 BEM，避免一次改完所有 SCSS。
 * 下一步可把两套收成 `statistics-chart-card` + `--home` / `--board` modifier。
 */
export const BOARD_CHART_CARD_CLASS = {
	[CHART_CARD_SURFACE.HOME]: {
		// 保留 Bootstrap card 视觉（与首页其它 Card 协调）；根节点仍是 article
		root: 'card dashboard-home-chart-card h-100',
		rootMap: 'dashboard-home-chart-card--map',
		header: 'card-header dashboard-home-chart-card__header',
		head: 'dashboard-home-chart-card__head',
		headMain: 'dashboard-home-chart-card__head-main',
		headMainDraggable: 'dashboard-home-chart-card__head-main--draggable',
		meta: 'dashboard-home-chart-card__meta',
		title: 'dashboard-home-chart-card__title dashboard-stat-card__title mb-0',
		body: 'card-body dashboard-home-chart-card__body',
		preview: 'dashboard-home-chart-card__preview',
		previewFixed: 'dashboard-home-chart-card__preview--fixed-slot',
		previewMap: 'dashboard-home-chart-card__preview--map',
		resizeHandle: 'dashboard-home-chart-card__resize-handle',
	},
	[CHART_CARD_SURFACE.SNAPSHOT]: {
		root: 'statistics-persisted-chart-card',
		rootMap: null,
		header: 'statistics-persisted-chart-card__head',
		head: null,
		headMain: 'statistics-persisted-chart-card__head-main',
		headMainDraggable: 'statistics-persisted-chart-card__head-main--draggable',
		meta: 'statistics-persisted-chart-card__meta',
		title: 'statistics-persisted-chart-card__title mb-0',
		body: null,
		preview: 'statistics-persisted-chart-card__preview',
		previewFixed: 'statistics-persisted-chart-card__preview--fixed-slot',
		previewTall: 'statistics-persisted-chart-card__preview--tall-slot',
		previewMap: null,
		resizeHandle: 'statistics-persisted-chart-card__resize-handle',
	},
};

export function getBoardChartCardClass(surface) {
	return BOARD_CHART_CARD_CLASS[surface] ?? null;
}
